module.exports = __webpack_public_path__ + "static/media/graphite-logo.afe5d6fa.svg";